import styled from "@emotion/styled";

import { MDSIconKind, MDSText, MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds";
import { AgentObjectHeroCard } from "@/pages/agent/components/agent-object-hero-card";
import { AgentOpenTasksBadge } from "@/pages/agent/components/agent-open-tasks-badge";
import { AgentRowActionButton } from "@/pages/agent/components/agent-row-action-button";
import type { ProjectDetailViewModel } from "@/pages/agent/project/agent-project-page.utils";
import { decodeAgentDisplayText } from "@/pages/agent/utils/agent-display-text.utils";

export const AgentProjectDetailCard = ({
  projectDetail,
  onOpenActivities,
}: {
  projectDetail: ProjectDetailViewModel;
  onOpenActivities: ({ projectId }: { projectId: string }) => void;
}) => {
  const projectTitle = projectDetail.project.title || "Untitled project";
  const description = projectDetail.project.description?.trim();
  const nextFollowUp = projectDetail.nextFollowUp;

  return (
    <AgentObjectHeroCard
      actions={
        <AgentRowActionButton
          aria-label={`Open activity for ${projectTitle}`}
          iconKind={MDSIconKind.History}
          onClick={() => {
            onOpenActivities({ projectId: projectDetail.project.id });
          }}
        />
      }
      ariaLabel={`Project: ${projectTitle}`}
      context={
        projectDetail.openTasksCount > 0 ? (
          <AgentOpenTasksBadge openTasksCount={projectDetail.openTasksCount} />
        ) : (
          <MDSText color={MDSTextColor.Tertiary} variant={MDSTextVariant.TextXs}>
            No open tasks
          </MDSText>
        )
      }
      description={description}
      status={projectDetail.project.status}
      title={projectTitle}
    >
      <StyledNextFollowUpLine>
        <MDSText
          color={MDSTextColor.Primary}
          variant={MDSTextVariant.TextS}
          weight={MDSTextWeight.SemiBold}
        >
          Next follow-up:
        </MDSText>
        {nextFollowUp ? (
          <MDSText color={MDSTextColor.Secondary} variant={MDSTextVariant.TextS}>
            {decodeAgentDisplayText({ value: nextFollowUp.content || "Untitled follow-up" })}
          </MDSText>
        ) : (
          <MDSText color={MDSTextColor.Tertiary} variant={MDSTextVariant.TextS}>
            None scheduled
          </MDSText>
        )}
      </StyledNextFollowUpLine>
    </AgentObjectHeroCard>
  );
};

const StyledNextFollowUpLine = styled.div`
  align-items: baseline;
  display: flex;
  gap: ${({ theme }) => theme.spacing[1]};
  min-width: 0;
`;
